import { keccak256, PublicClient } from "viem";
import { HDAccount, LocalAccount, signTransaction } from "viem/accounts";

export async function viemPublicViemClientSendTx(
	viem_public_client: PublicClient,
	account: HDAccount | LocalAccount,
	params: Parameters<typeof signTransaction>[0]["transaction"]
) {
	if(params.nonce === undefined) {
		params.nonce = await viem_public_client.getTransactionCount({ address: account.address });
	}

	if(params.chainId === undefined) {
		if(!viem_public_client.chain) {
			throw new Error(`RPC chain id not defined`);
		}
		params.chainId = viem_public_client.chain.id;
	}

	if(params.gas === undefined) {
		throw new Error(`Gas not defined`);
	}

	if(params.maxFeePerGas === undefined || params.maxPriorityFeePerGas === undefined) {
		const fees_data = await viem_public_client.estimateFeesPerGas();
		if(params.maxFeePerGas === undefined) {
			params.maxFeePerGas = fees_data.maxFeePerGas;
		}
		if(params.maxPriorityFeePerGas === undefined) {
			params.maxPriorityFeePerGas = fees_data.maxPriorityFeePerGas;
		}
	}

	if(params.to === undefined) {
		throw new Error(`To not defined`);
	}

	if(params.data === undefined) {
		throw new Error(`Data not defined`);
	}

	if(!account.signTransaction) {
		throw new Error(`Account cannot sign transactions`);
	}

	const tx = {
  	...params,
	} as const;

	const serialized_tx = await account.signTransaction(tx)
	const tx_hash = keccak256(serialized_tx);

	const res_tx_hash = await viem_public_client.sendRawTransaction({ serializedTransaction: serialized_tx });

	if(tx_hash !== res_tx_hash) {
		// This should never happen
	}

	return res_tx_hash;
}
